import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import MyGreating from './comp/MyGreating'
import Nombre from './comp/Nombre'
import Todo from './comp/Todo'
import {todos} from './comp/data'
import Gallery from './comp/Gallery'
import AddUser from './comp/AddUser'
import { useState } from 'react'



function App() {

  const [ todoList, setTodoList] = useState(todos)

  function mejTodos(person){
    setTodoList(
       [
        ...todoList,
        {
            id: todoList.length+1,
            title: person.title,
            description: person.description,
            imageUrl: person.imageUrl,
            complited: false
        }
      ]
    ) 
  } 

  return (
    <div className="App">
      <Container>
      <div>
        <MyGreating team="Fullstack"  />
      </div>
      <Row>
      <Col>
      <Todo todos={todoList}/>
      <Nombre todos={todoList}/>
      <hr/> 
      </Col>
      <Col>
        <Gallery todos={todoList}/>   
      <hr/> 
        <AddUser mejTodos={mejTodos} newId={todoList.length+1}/>
        </Col>
        </Row>
      </Container>
    </div>
  )
}

export default App
